module.exports = __webpack_public_path__ + "static/media/Assets-01-Vienna-Town-Hall-01.136df2fa.png";